module.exports = "/lucky-balls/img/bonus_yellow/number_picked.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/number_picked.png
// module id = 974
// module chunks = 0